(() => {
  const root = document.querySelector('[data-eldra-collection-hub]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = root.querySelectorAll('.eldra-reveal');
  items.forEach((item, index) => {
    item.style.setProperty('--eldra-reveal-delay', `${Math.min(index % 6, 5) * 70}ms`);
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

  items.forEach((item) => observer.observe(item));
})();
